module.exports = __webpack_public_path__ + "static/media/Video_Time-Based.54e46298.gif";